
import React from 'react';

interface FeatureCardProps {
  item: {
    icon: React.ReactNode;
    title: string;
    description: string;
    gradient: string;
  };
  index: number;
}

const FeatureCard = ({ item, index }: FeatureCardProps) => {
  return (
    <div
      className={`relative group text-center p-8 rounded-3xl backdrop-blur-xl 
        bg-gradient-to-br ${item.gradient} border border-white/10
        hover:border-white/30 transition-all duration-500 cursor-pointer
        shadow-lg hover:shadow-2xl`}
    >
      {/* Glow effect */}
      <div className={`absolute inset-0 rounded-3xl bg-gradient-to-br ${item.gradient} 
        opacity-0 group-hover:opacity-30 transition-opacity duration-500 blur-xl`} />
      
      <div className="relative z-10">
        <div className="flex justify-center mb-6">
          {item.icon}
        </div>
        <h3 className="text-2xl font-semibold text-white mb-4">
          {item.title}
        </h3>
        <p className="text-gray-300 leading-relaxed opacity-80 group-hover:opacity-100 transition-opacity duration-300">
          {item.description}
        </p>
      </div>
    </div>
  );
};

export default FeatureCard;
